import { faCalendar, faClock, faHashtag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate, isDate } from "utils/dateHelperFunctions";

import type { Appointment } from "models";

type AppointmentInfoType = {
  appointment: Appointment;
};

export const AppointmentInfo = ({ appointment }: AppointmentInfoType) => {
  const { t } = useTranslation();

  return (
    <div className="info-section">
      <div className="section-header">
        <span>{t("v8_appointment_information", "Appointment information")}</span>
      </div>
      <div className="section-content">
        <Grid>
          <Grid.Column width={4}>
            <span className="icon-text">
              {t("v8_wo", "WO")} <FontAwesomeIcon icon={faHashtag} className="i-green mr-5" />
            </span>
            {appointment.wo_nr}
          </Grid.Column>

          <Grid.Column width={4}>
            <span className="icon-text">
              {t("v8_reg", "Reg.")} <FontAwesomeIcon icon={faHashtag} className="i-green mr-5" />
            </span>
            {appointment.reg_number}
          </Grid.Column>

          {appointment.due_in && (isDate(appointment.due_in) || !appointment.due_in.startsWith("0001-01-01T00:00:00")) ? (
            <>
              <Grid.Column width={4}>
                <FontAwesomeIcon icon={faCalendar} className="i-green mr-5" />
                {formatDate(appointment.due_in, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>

              <Grid.Column width={4}>
                <FontAwesomeIcon icon={faClock} className="i-green mr-5" />
                {formatDate(appointment.due_in, DATE_FORMATS_FNS.hoursMinutes)}
              </Grid.Column>
            </>
          ) : (
            appointment.time_car_app &&
            (isDate(appointment.time_car_app) || !appointment.time_car_app.startsWith("0001-01-01T00:00:00")) && (
              <Grid.Column width={4}>
                <FontAwesomeIcon icon={faCalendar} className="i-green mr-5" />
                {formatDate(appointment.time_car_app, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>
            )
          )}
        </Grid>
      </div>
    </div>
  );
};
